<template>
  <div>
    <label class="labelTitle" v-if="label" >{{ label }} <BaseRequiredField v-if="isMandatory" /></label>
    <div
      class="radio-button-group switch-field"
      style="height: auto;">
      <label
        class="kt-radio kt-radio--solid"
        v-for="(option, index) in options"
        :key="index"
        :class="{ 'active': (String(option.value) === String(value)), 'is-invalid': validator ? validator.$error : '' }">
          <input
            type="radio"
            @input="updateValue"
            :value="option.value"
            v-bind="$attrs"
            :checked="String(option.value) === String(value)"> {{ option.text }}<slot />
          <span class="ttcRadiobutton"></span>
      </label>

    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseRadioButtonGroup',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    isMandatory: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      required: false
    },
    value: [String, Number]
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-button-group {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
